import { lazy } from 'react';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';
import type { BadgeDetailPageProps } from './components/BadgeDetailPageContent';

const BadgeDetailPageContent = lazy(
  () => import('./components/BadgeDetailPageContent'),
);

export const BadgeDetailPage = wrapNavigatorScreen(
  (props: BadgeDetailPageProps) => {
    return <BadgeDetailPageContent {...props} />;
  },
  { headerShown: false },
);
